<script setup>
const props = defineProps({
  state: {
    type: Number,
    default: 2
  }
})
</script>

<template>
  <el-text type="success" v-if="props.state === 1">上架</el-text>
  <el-text type="danger" v-else-if="props.state === 0">下架</el-text>
  <el-text type="info" v-else-if="props.state === 2">未上架</el-text>
  <el-text type="danger" v-else-if="props.state === -1">强制下架</el-text>
  <el-text type="info" v-else>未知状态</el-text>
</template>

<style scoped>

</style>
